import { useEffect, useState, type CSSProperties } from 'react'

import { getActiveUserId } from '@/api/identity'

import { MascotFigure } from './mascot/MascotFigure'
import './celebration.css'

// Только после «Завершить», один раз на устройстве для этой тренировки и владельца.
const seenKey = () => `telos.level-celebration:${getActiveUserId()}`

function seenSessions(): string[] {
  try {
    const raw = sessionStorage.getItem(seenKey())
    if (!raw) return []
    if (!raw.startsWith('[')) return [raw]
    const value: unknown = JSON.parse(raw)
    return Array.isArray(value) ? value.filter((item): item is string => typeof item === 'string') : []
  } catch {
    return []
  }
}

export function LevelCelebration({ sessionId, level }: { sessionId: string; level: number }) {
  const [active, setActive] = useState(() => !seenSessions().includes(sessionId))
  useEffect(() => {
    try {
      sessionStorage.setItem(seenKey(), JSON.stringify([...new Set([...seenSessions(), sessionId])].slice(-100)))
    } catch { /* memory only */ }
    const timer = window.setTimeout(() => setActive(false), 3600)
    return () => window.clearTimeout(timer)
  }, [sessionId])
  return (
    <div className="level-celebration relative mb-4 flex items-center gap-3 overflow-hidden rounded-lg bg-accent-soft px-3 py-2" role="status">
      <div className={active ? 'level-celebration-mascot' : ''}>
        <MascotFigure mood="cheer" level={level} className="size-16" />
      </div>
      <p className="text-sm font-medium text-fg">Уровень {level} взят!<span className="mt-0.5 block font-normal">Ещё один шаг вперёд.</span></p>
      {active ? <div className="pointer-events-none absolute inset-0" aria-hidden>
        {Array.from({ length: 24 }, (_, i) => <i key={i} className="level-confetti" style={{
          '--x': `${(i * 37) % 100}%`, '--drift': `${(i % 2 ? 1 : -1) * (20 + i % 5 * 10)}px`,
          '--delay': `${(i % 6) * 70}ms`, '--color': ['var(--accent)', 'var(--muscle-primary)', 'var(--muscle-secondary)'][i % 3],
        } as CSSProperties} />)}
      </div> : null}
    </div>
  )
}
